function identity(value) {
    return value;
}

export { identity as default };
